import classnames from 'classnames';
import ReactSelect, { components } from 'react-select';
import IconChevronDown from '@scramble/design-system/icons/chevron-down.svg?react';
import s from './index.module.scss';

const ChevronDown = () => <IconChevronDown width={20} height={20} aria-hidden="true" />;

const DropdownIndicator = (props) => (
  <components.DropdownIndicator {...props}>
    <ChevronDown />
  </components.DropdownIndicator>
);

export const Select = ({ label, name, error, className, ...props }) => {
  return (
    <div className={classnames(s.wrapper, className)}>
      {label && (
        <label className="f-small-accent" htmlFor={name}>
          {label}
        </label>
      )}
      <ReactSelect
        inputId={name}
        name={name}
        classNamePrefix="compliance_select"
        className={classnames(s.select, error && s.select_error)}
        components={{ DropdownIndicator }}
        {...props}
      />
      {error && <div className={s.error_message}>{error}</div>}
    </div>
  );
};